import type { NewCoreIconProps } from '@atlaskit/icon';

export type FocusAreaStatuses =
	| 'pending'
	| 'paused'
	| 'on_track'
	| 'off_track'
	| 'at_risk'
	| 'completed';

export function isFocusAreaStatus(status: string): status is FocusAreaStatuses {
	return (
		['pending', 'paused', 'on_track', 'off_track', 'at_risk', 'completed'].indexOf(status) !== -1
	);
}

export interface FocusAreaIconProps {
	/**
	 * Determines the color of the focus area icon based on status
	 */
	status?: FocusAreaStatuses;

	/**
	 * Overrides the status color with a custom color token
	 */
	customColor?: NewCoreIconProps['color'];

	/**
	 * Determines the spacing of the icon
	 * Size has been deprecated and replaced with spacing
	 * https://hello.atlassian.net/wiki/spaces/DST/pages/3748692796
	 */
	spacing?: NewCoreIconProps['spacing'];

	/**
	 * Test id for container element
	 */
	testId?: string;

	/**
	 * Accessible description for the focus area icon
	 */
	label?: string;
}
